var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('zone',{attrs:{"isAdmin":true,"height":100},on:{"rowSelected":function($event){return _vm.rowSelected($event)}}},[_vm._v(" > ")])],1),_c('v-col',{attrs:{"lg":"6"}},[_c('sub-zone',{attrs:{"isAdmin":true,"ZonID":_vm.ZonID,"height":200}},[_vm._v(" > ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }